import React from "react";
import Button from "@mui/material/Button";


/*
  <ButtonContainer text={"Delete items & Continue"} variantVal={"contained"} isError={false} isLoading={false} />
  variant => contained/outlined
*/

interface Props {
  text: string,
  variantVal: any,
  size?: any,
  isError?: boolean,
  isLoading?: boolean,
  parentFunc: (...args: any[]) => void,
  textColor?: string,
  paddingVal?: string,
  borderRadiusVal?: string,
  disabled?: boolean,
  width?: string,
  height?: string,
  textSize?: string,
  customClass?: string,
  textCustomClass?: string,
  borderColor?: string,
  hoverBorderColor?: string,
  bgColor?: string,
  id?: string;
  hoverText?: string;
}

const ButtonContainer: React.FC<Props> = ({
  text,
  variantVal = 'outlined',
  isError = false,
  isLoading = false,
  parentFunc,
  textColor,
  paddingVal,
  borderRadiusVal,
  disabled = false,
  width = 'intial',
  height = 'intial',
  textSize = '',
  customClass = '',
  textCustomClass = '',
  size = 'medium',
  borderColor = '',
  hoverBorderColor = '',
  bgColor = '',
  id = '',
  hoverText = '',
}) => {

  const handleClick = () => {
    parentFunc();
  };

  return (
    <Button
      id={id}
      variant={variantVal}
      title={hoverText}
      sx={{
        color: variantVal === "contained" ? "#fff" : isError ? "#E24747" : textColor ? textColor : "#3D6AFD",
        backgroundColor: bgColor || (variantVal === "contained" ? "#3D6AFD" : "#fff"),
        borderColor: borderColor || (variantVal === "contained" ? "#3D6AFD" : "#E4E5EC"),
        padding: paddingVal ? paddingVal : "",
        borderRadius: borderRadiusVal ? borderRadiusVal : "",
        border : 1,
        opacity: disabled ? "0.5" : "1",
        width: width,
        height: height,
        "&&:hover": {
          backgroundColor: bgColor || (variantVal === "contained" ? "#3D6AFD" : "#fff"),
          borderColor: hoverBorderColor || (variantVal === "contained" ? "#3D6AFD" : "#E4E5EC")
        }
      }}
      onClick={handleClick}
      disabled={isLoading || disabled}
      className={customClass || ''}
      size={size}
    >
      <span className={`font-inter font-semibold normal-case ${textCustomClass || ''} ${textSize ? textSize : "text-14"}`}>
        {isLoading ? "Loading…" : text}
      </span>
    </Button>
  );
}

export default ButtonContainer;
